import React, { useState, useEffect, useContext } from 'react';
import VisuallyHiddenAnnouncementContext, { RefElementType } from 'VisuallyHiddenAnnouncementContext';

interface VisuallyHiddenAnnouncementProps {
	children: React.ReactNode;
}

/**
 * Displays a page change alert for screen readers
 *
 * @param {*} props
 * @returns
 */
function VisuallyHiddenAnnouncement(props: VisuallyHiddenAnnouncementProps) {
	const [alert, setAlert] = useState('');
	const [mainRef, setMainRef] = useState<RefElementType | null>(null);

	return (
		<VisuallyHiddenAnnouncementContext.Provider value={{ setAlert, mainRef, setMainRef }}>
			{props.children}
			<div className="visually-hidden" role="status" aria-live="assertive" aria-atomic="true">
				{alert}
			</div>
		</VisuallyHiddenAnnouncementContext.Provider>
	);
}

export default VisuallyHiddenAnnouncement;

interface VisuallyHiddenAnnouncementTriggerProps {
	message: string;
}

/**
 * Triggers a page change alert
 *
 * @export
 * @param {VisuallyHiddenAnnouncementTriggerProps} props
 * @returns
 */
export function VisuallyHiddenAnnouncementTrigger(props: VisuallyHiddenAnnouncementTriggerProps) {
	const { setAlert, mainRef } = useContext(VisuallyHiddenAnnouncementContext);

	// on "mount" set the alert.
	useEffect(() => {
		setAlert(props.message);

		if (!mainRef || !mainRef.current) {
			return;
		}

		mainRef.current.focus();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props.message]);

	return null;
}
